import React, { useEffect, useState } from 'react';
import { Card, Input, Button, List, Avatar, Space } from 'antd';
import {
  SendOutlined,
  UserOutlined,
  CustomerServiceOutlined,
} from '@ant-design/icons';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getUserById } from '../../store/slices/userSlice';
import axios from 'axios';
import io from 'socket.io-client';
const baseUrl = process.env.REACT_APP_BASE_URL || "http://localhost:5000/api"
const socket = io(baseUrl.replace('/api', ''));

const { TextArea } = Input;

const CustomerChat = () => {
    const { id } = useParams();
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(getUserById(id))
    }, [dispatch, id])
    const { userData } = useSelector((state) => state?.user)
    const loginData = useSelector((state) => state?.auth?.after_login_data)
    const [message, setMessage] = useState('');
    const [messages, setMessages] = useState([
        // {
        //     id: 1,
        //     sender: 'customer',
        //     text: 'Hello, I need help with my account.',
        //     time: '10:30 AM',
        // },
        // {
        //     id: 2,
        //     sender: 'agent',
        //     text: 'Sure! How can I assist you?',
        //     time: '10:31 AM',
        // },
    ]);

    useEffect(() => {
        console.log(baseUrl.replace('/api', ''))
        if (!loginData?.data?._id || !id) return;
        axios.get(`${baseUrl}/user/messages/get/${loginData?.data?._id}/${id}`)
        .then((res) => {
            setMessages(res?.data?.messages);
            console.log(res?.data?.messages)
        })
        .catch((err) => console.error('Error fetching messages', err));
    }, [loginData?.data, id]);

    useEffect(() => {
        socket.on('private message', (msg) => {
        // Only display if relevant to current chat
        if (
            (msg.sender_id == id && msg.receiver_id == loginData?.data?._id) ||
            (msg.sender_id == loginData?.data?._id && msg.receiver_id == id)
        ) {
            setMessages((prev) => [...prev, msg]);
        }
        });
        return () => {
            socket.off('private message');
        };
    }, [id, loginData?.data?._id]);

    const handleSend = () => {
        if (!message.trim()) return;

        if (message.trim()) {
            socket.emit('private message', {
                senderId: loginData?.data?._id,
                receiverId: id,
                message
            });
            setMessage('');
        }

        // setMessages([
        //     ...messages,
        //     {
        //     id: Date.now(),
        //     sender: 'agent',
        //     text: message,
        //     time: new Date().toLocaleTimeString([], {
        //         hour: '2-digit',
        //         minute: '2-digit',
        //     }),
        //     },
        // ]);

        // setMessage('');
    };

    return (
        <Card
            title={
            <Space>
                <CustomerServiceOutlined style={{ color: '#CA9AE8' }} />
                Chat with {userData?.data?.user?.first_name || 'Customer'}
            </Space>
            }
            style={{
            borderRadius: 12,
            height: 500,
            display: 'flex',
            flexDirection: 'column',
            }}
            bodyStyle={{
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            padding: 16,
            height: 100
            }}
        >
            {/* Messages */}
            <div style={{ flex: 1, overflowY: 'auto', paddingRight: 8 }}>
            <List
                dataSource={messages}
                renderItem={(item) => (
                <List.Item
                    style={{
                    justifyContent:
                        item.sender_id?._id === loginData?.data?._id || item.sender_id === loginData?.data?._id ? 'flex-end' : 'flex-start',
                    }}
                >
                    <Space align="start">
                    {item.receiver_id?._id === loginData?.data?._id || item.receiver_id === loginData?.data?._id && (
                        <Avatar icon={<UserOutlined />} />
                    )}

                    <div
                        style={{
                        maxWidth: 320,
                        padding: '10px 14px',
                        borderRadius: 12,
                        background:
                            item.sender_id?._id === loginData?.data?._id || item.sender_id === loginData?.data?._id ? '#CA9AE8' : '#f5f5f5',
                            color: item.sender_id?._id === loginData?.data?._id || item.sender_id === loginData?.data?._id ? '#fff' : '#000',
                        }}
                    >
                        <div style={{ fontSize: 14 }}>{item.message}</div>
                        <div
                        style={{
                            fontSize: 11,
                            opacity: 0.7,
                            textAlign: 'right',
                            marginTop: 4,
                        }}
                        >
                        {new Date(item.createdAt).toLocaleTimeString()}
                        </div>
                    </div>

                    {item.sender_id?._id === loginData?.data?._id || item.sender_id === loginData?.data?._id && (
                        <Avatar
                        style={{ backgroundColor: '#CA9AE8' }}
                        icon={<CustomerServiceOutlined />}
                        />
                    )}
                    </Space>
                </List.Item>
                )}
            />
            </div>

            {/* Input */}
            <Space style={{ marginTop: 12 }}>
            <TextArea
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Type a message..."
                autoSize={{ minRows: 1, maxRows: 3 }}
                onPressEnter={(e) => {
                e.preventDefault();
                handleSend();
                }}
            />
            <Button
                type="primary"
                icon={<SendOutlined />}
                onClick={handleSend}
                style={{ height: 40 }}
            />
            </Space>
        </Card>
    );
};

export default CustomerChat;
